var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-4",staticStyle:{"display":"flex","gap":"8px","background-color":"#e5f0fb"}},[_c('ReiseterminTableDetails',{attrs:{"reiseterminObject":_vm.params.data}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }